import { gql } from "@apollo/client";

export const MARK_ALL_NOTIFICATION_AS_READ = gql`
mutation markAllNotificationAsRead{
  markAllNotificationAsRead{
    messages
    success
  }
}
`;

export const MARK_NOTIFICATION_AS_READ = gql`
mutation markNotificationAsRead($notificationMessageId: String!){
    markNotificationAsRead(notificationMessageId: $notificationMessageId){
      messages
      success
    }
  }
`;
